/* eslint-disable camelcase */
import { extend } from 'vee-validate';
import { max, numeric, min, alpha_spaces } from 'vee-validate/dist/rules';

extend('min', {
  ...min,
  params: ['length'],
  message: 'Minimal {length} karakter',
});

extend('max', {
  ...max,
  params: ['length'],
  message: 'Maksimal {length} karakter',
});

extend('numeric', {
  ...numeric,
  message: 'Hanya dapat diisi dengan angka',
});

extend('alpha_spaces', {
  ...alpha_spaces,
  message: 'Hanya dapat diisi dengan huruf dan spasi',
});
